import Hamburger from './Hamburger';

export default Hamburger;